import { render, staticRenderFns } from "./WebNav.vue?vue&type=template&id=0c6d8cc9&scoped=true"
import script from "./WebNav.vue?vue&type=script&lang=js"
export * from "./WebNav.vue?vue&type=script&lang=js"
import style0 from "./WebNav.vue?vue&type=style&index=0&id=0c6d8cc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d8cc9",
  null
  
)

export default component.exports